var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    "data-name": "--Circle",
    fill: "none",
    id: "_--Circle",
    r: 10,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    x1: 12,
    x2: 12,
    y1: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    x1: 12,
    x2: 12,
    y1: 8,
    y2: 8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.3894e0cba7fb01551d0ac994eecf330e.svg";
export { ForwardRef as ReactComponent };